const React = require('react')
const Ledge = require('module/ledge/ledge')
const AnonymousLedgeView = require('./anonymous_ledge_view')
const log = require('log').create('anonymous ledge')  

class AnonymousLedge extends React.Component {

    componentDidMount() {
        log('componentDidMount')
        this.timer = setTimeout(() => {
            this.showLedge()
        }, 2000)
    }

    componentWillUnmount() {
        clearTimeout(this.timer)
        if (this.ledge) this.ledge.close()
    }

    showLedge() {
        this.ledge = new Ledge({
            ViewClass: AnonymousLedgeView,
        })
    }

    render() {
        return null
    }

}

module.exports = AnonymousLedge
